<div
  class="fixed bottom-0 left-0 right-0 z-50 flex flex-col bg-slate-1 text-slate-11 shadow-2xl transition-all duration-300 ease-in-out font-mono border-t border-slate-6"
  [class.h-10]="!isOpen()"
  [class.h-2/3]="isOpen()"
  [class.max-h-screen]="isOpen()"
>
  <!-- Workbench Header / Title Bar -->
  <div
    role="button"
    tabindex="0"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-label]="isOpen() ? 'Fermer le workbench' : 'Ouvrir le workbench des développeurs'"
    class="flex h-10 w-full cursor-pointer items-center justify-between px-4 hover:bg-slate-3 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-primary-9"
    (click)="toggle()"
    (keydown)="handleKeydown($event)"
  >
    <div class="flex items-center gap-4">
      <div class="font-bold text-slate-12 flex items-center gap-2">
        <mat-icon class="!text-[16px] !w-4 !h-4 flex items-center justify-center">terminal</mat-icon>
        {{ title() }}
      </div>
      @if (!isOpen()) {
        <ng-content select="[workbench-summary]"></ng-content>
      }
    </div>

    <div class="flex items-center gap-2 text-slate-11">
      <div tabindex="-1" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <ng-content select="[workbench-actions]"></ng-content>
      </div>
      <div
        class="hover:text-slate-12 p-1 rounded hover:bg-slate-4 transition-colors flex items-center justify-center"
      >
        @if (isOpen()) {
          <mat-icon class="!text-[16px] !w-4 !h-4 flex items-center justify-center">expand_more</mat-icon>
        } @else {
          <mat-icon class="!text-[16px] !w-4 !h-4 flex items-center justify-center">expand_less</mat-icon>
        }
      </div>
    </div>
  </div>

  @if (isOpen()) {
    <!-- Workbench Body -->
    <div
      class="flex-1 overflow-auto bg-slate-2 pb-4 transition-opacity duration-300 border-t border-slate-6"
      [class.opacity-0]="!isOpen()"
      [class.opacity-100]="isOpen()"
      [class.pointer-events-none]="!isOpen()"
    >
      <ng-content></ng-content>
    </div>
  }
</div>
